<!-- {@see PChipStyles.vue} -->

<template />

<style lang="postcss">
.s-button {
  @apply inline-flex cursor-pointer items-center justify-center rounded-md no-underline outline outline-1 outline-offset-2 outline-transparent transition-[color,background-color];

  --button-disabled-text: theme("colors.gray.500");
  --button-disabled-bg: theme("colors.gray.100");
  --button-disabled-border: theme("colors.gray.100");

  &--rounded {
    @apply rounded-full;
  }

  &--color {
    &-primary {
      --button-primary-bg: theme("colors.primary.700");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.primary.600");
      --button-primary-checked-ring-offset: theme("colors.primary.500");

      --button-primary-soft-bg: theme("colors.primary.600");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.primary.500");
      --button-primary-soft-checked-ring-offset: theme("colors.primary.400");

      --button-secondary-bg: theme("colors.primary.50");
      --button-secondary-text: theme("colors.primary.800");
      --button-secondary-hover-bg: theme("colors.primary.200");
      --button-secondary-checked-border: theme("colors.primary.700");

      --button-tertiary-border: theme("colors.primary.700");
      --button-tertiary-text: theme("colors.primary.700");
      --button-tertiary-hover-border: theme("colors.primary.600");
      --button-tertiary-hover-bg: theme("colors.primary.50");
      --button-tertiary-checked-border: theme("colors.primary.700");
      --button-tertiary-checked-bg: theme("colors.primary.50");

      --button-tertiary-soft-border: theme("colors.primary.200");
      --button-tertiary-soft-text: theme("colors.primary.700");
      --button-tertiary-soft-hover-bg: theme("colors.primary.50");
      --button-tertiary-soft-checked-border: theme("colors.primary.700");
      --button-tertiary-soft-checked-bg: theme("colors.primary.50");

      --button-quaternary-text: theme("colors.primary.700");
      --button-quaternary-hover-bg: theme("colors.primary.50");
      --button-quaternary-checked-border: theme("colors.primary.700");

      --button-link-color: theme("colors.primary.700");
      --button-link-hover-color: theme("colors.primary.600");
    }

    &-accent {
      --button-primary-bg: theme("colors.accent.500");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.accent.400");
      --button-primary-checked-ring-offset: theme("colors.accent.300");

      --button-primary-soft-bg: theme("colors.accent.400");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.accent.300");
      --button-primary-soft-checked-ring-offset: theme("colors.accent.200");

      --button-secondary-bg: theme("colors.accent.100");
      --button-secondary-text: theme("colors.accent.700");
      --button-secondary-hover-bg: theme("colors.accent.200");
      --button-secondary-checked-border: theme("colors.accent.500");

      --button-tertiary-border: theme("colors.accent.500");
      --button-tertiary-text: theme("colors.accent.500");
      --button-tertiary-hover-border: theme("colors.accent.400");
      --button-tertiary-hover-bg: theme("colors.accent.100");
      --button-tertiary-checked-border: theme("colors.accent.500");
      --button-tertiary-checked-bg: theme("colors.accent.100");

      --button-tertiary-soft-border: theme("colors.accent.200");
      --button-tertiary-soft-text: theme("colors.accent.500");
      --button-tertiary-soft-hover-bg: theme("colors.accent.50");
      --button-tertiary-soft-checked-border: theme("colors.accent.500");
      --button-tertiary-soft-checked-bg: theme("colors.accent.100");

      --button-quaternary-text: theme("colors.accent.500");
      --button-quaternary-hover-bg: theme("colors.accent.100");
      --button-quaternary-checked-border: theme("colors.accent.500");

      --button-link-color: theme("colors.accent.500");
      --button-link-hover-color: theme("colors.accent.400");
    }

    &-success {
      --button-primary-bg: theme("colors.success.500");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.success.400");
      --button-primary-checked-ring-offset: theme("colors.success.300");

      --button-primary-soft-bg: theme("colors.success.400");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.success.300");
      --button-primary-soft-checked-ring-offset: theme("colors.success.200");

      --button-secondary-bg: theme("colors.success.100");
      --button-secondary-text: theme("colors.success.700");
      --button-secondary-hover-bg: theme("colors.success.200");
      --button-secondary-checked-border: theme("colors.success.500");

      --button-tertiary-border: theme("colors.success.500");
      --button-tertiary-text: theme("colors.success.500");
      --button-tertiary-hover-border: theme("colors.success.400");
      --button-tertiary-hover-bg: theme("colors.success.100");
      --button-tertiary-checked-border: theme("colors.success.500");
      --button-tertiary-checked-bg: theme("colors.success.100");

      --button-tertiary-soft-border: theme("colors.success.200");
      --button-tertiary-soft-text: theme("colors.success.500");
      --button-tertiary-soft-hover-bg: theme("colors.success.50");
      --button-tertiary-soft-checked-border: theme("colors.success.500");
      --button-tertiary-soft-checked-bg: theme("colors.success.100");

      --button-quaternary-text: theme("colors.success.500");
      --button-quaternary-hover-bg: theme("colors.success.100");
      --button-quaternary-checked-border: theme("colors.success.500");

      --button-link-color: theme("colors.success.500");
      --button-link-hover-color: theme("colors.success.400");
    }

    &-warning {
      --button-primary-bg: theme("colors.warning.500");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.warning.400");
      --button-primary-checked-ring-offset: theme("colors.warning.300");

      --button-primary-soft-bg: theme("colors.warning.400");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.warning.300");
      --button-primary-soft-checked-ring-offset: theme("colors.warning.200");

      --button-secondary-bg: theme("colors.warning.100");
      --button-secondary-text: theme("colors.warning.700");
      --button-secondary-hover-bg: theme("colors.warning.200");
      --button-secondary-checked-border: theme("colors.warning.500");

      --button-tertiary-border: theme("colors.warning.500");
      --button-tertiary-text: theme("colors.warning.500");
      --button-tertiary-hover-border: theme("colors.warning.400");
      --button-tertiary-hover-bg: theme("colors.warning.100");
      --button-tertiary-checked-border: theme("colors.warning.500");
      --button-tertiary-checked-bg: theme("colors.warning.100");

      --button-tertiary-soft-border: theme("colors.warning.200");
      --button-tertiary-soft-text: theme("colors.warning.500");
      --button-tertiary-soft-hover-bg: theme("colors.warning.50");
      --button-tertiary-soft-checked-border: theme("colors.warning.500");
      --button-tertiary-soft-checked-bg: theme("colors.warning.100");

      --button-quaternary-text: theme("colors.warning.500");
      --button-quaternary-hover-bg: theme("colors.warning.100");
      --button-quaternary-checked-border: theme("colors.warning.500");

      --button-link-color: theme("colors.warning.500");
      --button-link-hover-color: theme("colors.warning.400");
    }

    &-danger {
      --button-primary-bg: theme("colors.danger.500");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.danger.400");
      --button-primary-checked-ring-offset: theme("colors.danger.300");

      --button-primary-soft-bg: theme("colors.danger.400");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.danger.300");
      --button-primary-soft-checked-ring-offset: theme("colors.danger.200");

      --button-secondary-bg: theme("colors.danger.100");
      --button-secondary-text: theme("colors.danger.700");
      --button-secondary-hover-bg: theme("colors.danger.200");
      --button-secondary-checked-border: theme("colors.danger.500");

      --button-tertiary-border: theme("colors.danger.500");
      --button-tertiary-text: theme("colors.danger.500");
      --button-tertiary-hover-border: theme("colors.danger.400");
      --button-tertiary-hover-bg: theme("colors.danger.100");
      --button-tertiary-checked-border: theme("colors.danger.500");
      --button-tertiary-checked-bg: theme("colors.danger.100");

      --button-tertiary-soft-border: theme("colors.danger.200");
      --button-tertiary-soft-text: theme("colors.danger.500");
      --button-tertiary-soft-hover-bg: theme("colors.danger.50");
      --button-tertiary-soft-checked-border: theme("colors.danger.500");
      --button-tertiary-soft-checked-bg: theme("colors.danger.100");

      --button-quaternary-text: theme("colors.danger.500");
      --button-quaternary-hover-bg: theme("colors.danger.100");
      --button-quaternary-checked-border: theme("colors.danger.500");

      --button-link-color: theme("colors.danger.500");
      --button-link-hover-color: theme("colors.danger.400");
    }

    &-purple {
      --button-primary-bg: theme("colors.purple.600");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.purple.500");
      --button-primary-checked-ring-offset: theme("colors.purple.400");

      --button-primary-soft-bg: theme("colors.purple.500");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.purple.400");
      --button-primary-soft-checked-ring-offset: theme("colors.purple.300");

      --button-secondary-bg: theme("colors.purple.100");
      --button-secondary-text: theme("colors.purple.700");
      --button-secondary-hover-bg: theme("colors.purple.200");
      --button-secondary-checked-border: theme("colors.purple.600");

      --button-tertiary-border: theme("colors.purple.600");
      --button-tertiary-text: theme("colors.purple.600");
      --button-tertiary-hover-border: theme("colors.purple.500");
      --button-tertiary-hover-bg: theme("colors.purple.50");
      --button-tertiary-checked-border: theme("colors.purple.600");
      --button-tertiary-checked-bg: theme("colors.purple.100");

      --button-tertiary-soft-border: theme("colors.purple.200");
      --button-tertiary-soft-text: theme("colors.purple.600");
      --button-tertiary-soft-hover-bg: theme("colors.purple.50");
      --button-tertiary-soft-checked-border: theme("colors.purple.600");
      --button-tertiary-soft-checked-bg: theme("colors.purple.100");

      --button-quaternary-text: theme("colors.purple.600");
      --button-quaternary-hover-bg: theme("colors.purple.100");
      --button-quaternary-checked-border: theme("colors.purple.600");

      --button-link-color: theme("colors.purple.600");
      --button-link-hover-color: theme("colors.purple.500");

      --button-disabled-text: theme("colors.purple.300");
      --button-disabled-bg: theme("colors.purple.50");
      --button-disabled-border: theme("colors.purple.200");
    }

    &-gray {
      --button-primary-bg: theme("colors.gray.500");
      --button-primary-text: white;
      --button-primary-hover-bg: theme("colors.gray.400");
      --button-primary-checked-ring-offset: theme("colors.gray.300");

      --button-primary-soft-bg: theme("colors.gray.400");
      --button-primary-soft-text: white;
      --button-primary-soft-hover-bg: theme("colors.gray.300");
      --button-primary-soft-checked-ring-offset: theme("colors.gray.200");

      --button-secondary-bg: theme("colors.gray.100");
      --button-secondary-text: theme("colors.gray.700");
      --button-secondary-hover-bg: theme("colors.gray.200");
      --button-secondary-checked-border: theme("colors.gray.500");

      --button-tertiary-border: theme("colors.gray.500");
      --button-tertiary-text: theme("colors.gray.500");
      --button-tertiary-hover-border: theme("colors.gray.400");
      --button-tertiary-hover-bg: theme("colors.gray.100");
      --button-tertiary-checked-border: theme("colors.gray.500");
      --button-tertiary-checked-bg: theme("colors.gray.100");

      --button-tertiary-soft-border: theme("colors.gray.200");
      --button-tertiary-soft-text: theme("colors.gray.500");
      --button-tertiary-soft-hover-bg: theme("colors.gray.50");
      --button-tertiary-soft-checked-border: theme("colors.gray.500");
      --button-tertiary-soft-checked-bg: theme("colors.gray.100");

      --button-quaternary-text: theme("colors.gray.500");
      --button-quaternary-hover-bg: theme("colors.gray.100");
      --button-quaternary-checked-border: theme("colors.gray.500");

      --button-link-color: theme("colors.gray.500");
      --button-link-hover-color: theme("colors.gray.400");
    }
  }

  &--action-primary {
    @apply bg-[var(--button-primary-bg)] text-[var(--button-primary-text)];

    @apply hover:bg-[var(--button-primary-hover-bg)] hover:text-[var(--button-primary-text)];
    @apply active:bg-[var(--button-primary-hover-bg)] active:text-[var(--button-primary-text)];
    @apply group-hover:bg-[var(--button-primary-hover-bg)] group-hover:text-[var(--button-primary-text)];

    &.s-button {
      &--disabled,
      &--disabled:hover {
        @apply bg-[var(--button-disabled-bg)];
      }
    }
  }

  &--action-primary-soft {
    @apply bg-[var(--button-primary-soft-bg)] text-[var(--button-primary-soft-text)];

    @apply hover:bg-[var(--button-primary-soft-hover-bg)] hover:text-[var(--button-primary-soft-text)];
    @apply active:bg-[var(--button-primary-soft-hover-bg)] active:text-[var(--button-primary-soft-text)];
    @apply group-hover:bg-[var(--button-primary-soft-hover-bg)] group-hover:text-[var(--button-primary-soft-text)];

    &.s-button {
      &--disabled,
      &--disabled:hover {
        @apply bg-[var(--button-disabled-bg)];
      }
    }
  }

  &--action-secondary {
    @apply bg-[var(--button-secondary-bg)] text-[var(--button-secondary-text)];

    @apply hover:bg-[var(--button-secondary-hover-bg)] hover:text-[var(--button-secondary-text)];
    @apply active:bg-[var(--button-secondary-hover-bg)] active:text-[var(--button-secondary-text)];
    @apply group-hover:bg-[var(--button-secondary-hover-bg)] group-hover:text-[var(--button-secondary-text)];

    &.s-button {
      &--disabled,
      &--disabled:hover {
        @apply bg-[var(--button-disabled-bg)];
      }
    }
  }

  &--action-tertiary {
    @apply border border-[var(--button-tertiary-border)] bg-white text-[var(--button-tertiary-text)];

    @apply hover:border-[var(--button-tertiary-hover-border)] hover:bg-[var(--button-tertiary-hover-bg)];
    @apply active:border-[var(--button-tertiary-hover-border)] active:bg-[var(--button-tertiary-hover-bg)];
    @apply group-hover:border-[var(--button-tertiary-hover-border)] group-hover:bg-[var(--button-tertiary-hover-bg)];

    &.s-button {
      &--disabled,
      &--disabled:hover {
        @apply border-[var(--button-disabled-border)] bg-transparent;
      }
    }
  }

  &--action-tertiary-soft {
    @apply border border-[var(--button-tertiary-soft-border)] bg-white text-[var(--button-tertiary-soft-text)];

    @apply hover:bg-[var(--button-tertiary-soft-hover-bg)];
    @apply active:bg-[var(--button-tertiary-soft-hover-bg)];
    @apply group-hover:bg-[var(--button-tertiary-soft-hover-bg)];

    &.s-button {
      &--disabled,
      &--disabled:hover {
        @apply border-[var(--button-disabled-border)] bg-transparent;
      }

      &--disabled&--opaque {
        @apply bg-[var(--button-disabled-bg)];
      }
    }
  }

  &--action-quaternary {
    @apply text-[var(--button-quaternary-text)];

    @apply hover:bg-[var(--button-quaternary-hover-bg)];
    @apply active:bg-[var(--button-quaternary-hover-bg)];
    @apply group-hover:bg-[var(--button-quaternary-hover-bg)];
    @apply group-focus:bg-[var(--button-quaternary-hover-bg)];

    &.s-button {
      &--opaque:not(:hover) {
        @apply bg-white;
      }

      &--disabled:hover {
        @apply bg-transparent;
      }

      &--disabled&--opaque {
        @apply bg-white;
      }
    }
  }

  @apply group-focus:outline-primary-600;
  &:focus-visible,
  &--focused {
    @apply outline outline-1 outline-primary-600;
  }

  &--invalid {
    @apply outline-danger-500;
  }

  &--disabled,
  &--disabled:hover {
    @apply cursor-not-allowed text-[var(--button-disabled-text)];
  }
}
</style>
